import type { Handler } from 'mitt';
import mitt from 'mitt';

const emitter = mitt();

export default {
  $on: (type: string, handler: Handler) => emitter.on(type, handler),
  $off: (type: string, handler?: Handler) => emitter.off(type, handler),
  $emit: (type: string, event?: any) => emitter.emit(type, event)
};
